import { SortingElement } from '../components/filtering/components/SortingCard';

export function serialiseSorting(sorting: SortingElement[]) {
  return sorting.map(element => element.join(',')).join(';');
}
